<template>
    <div id="requirements">
        <section class="section">
            <div class="container">
                <div class="section-heading heading-light">
                    <span class="subtitle primary">Requisitos</span>
                    <h2 class="mb--50 black font-weight-100">
                        ¿Qué necesito para <span class="bold">solicitar</span> el crédito?
                    </h2>
                </div>

                <div class="row">
                    <div class="col-sm-6 col-md-3 mb--20">
                        <div class="check-card">
                            <i class="fal fa-check"></i>
                            <p class="mb-0 h6 bold">
                                Ser mayor de edad
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-3 mb--20">
                        <div class="check-card">
                            <i class="fal fa-check"></i>
                            <p class="mb-0 h6 bold">
                                Contar con buen historial legal y crediticio
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-3 mb--20">
                        <div class="check-card">
                            <i class="fal fa-check"></i>
                            <p class="mb-0 h6 bold">
                                Comprobar ingresos
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-3 mb--20">
                        <div class="check-card">
                            <i class="fal fa-check"></i>
                            <p class="mb-0 h6 bold">
                                Cuenta de banco a tu nombre
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "CoinsBanner",
    components: {
    }
}

</script>

<style scoped>
.check-card {
    background-color: transparent;
    border: solid 3px var(--color-primary);
    border-radius: 30px;
    text-align: center;
    color: var(--color-primary);
    font-weight: 700;
    min-height: 100%;
    padding: 3rem;
    display: flex;
    align-items: center;
    position: relative;
}

    .check-card p {
        line-height: 1;
    }

    .check-card i {
        position: absolute;
        top: 20px;
        left: 20px;
    }

    .fal {
        font-weight: 700;
    }
</style>